<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import ButtonGroup from 'dashboard/components-next/buttonGroup/ButtonGroup.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import {
  LILITH_CONVERSATION_AI_FEATURE,
  isLilithTeamAssistAvailable,
  isLilithTeamAssistConversationRoute,
} from 'dashboard/routes/dashboard/lilith/lilithSurfaces';

const route = useRoute();
const { uiSettings, updateUISettings } = useUISettings();
const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const isAvailable = computed(() =>
  isLilithTeamAssistAvailable({
    accountEntitled: isFeatureEnabledonAccount.value(
      currentAccountId.value,
      LILITH_CONVERSATION_AI_FEATURE
    ),
  })
);

const showLauncher = computed(
  () =>
    isAvailable.value &&
    !uiSettings.value.is_copilot_panel_open &&
    !isLilithTeamAssistConversationRoute(route.name)
);

const togglePanel = () => {
  updateUISettings({
    is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <div v-if="showLauncher" class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50">
    <ButtonGroup
      class="rounded-full bg-n-alpha-2 backdrop-blur-lg p-1 shadow hover:shadow-md"
    >
      <Button
        v-tooltip.top="$t('TEAM_LILITH.TITLE')"
        icon="i-lucide-sparkles"
        no-animation
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl transition-all duration-200 ease-out hover:brightness-110"
        lg
        @click="togglePanel"
      />
    </ButtonGroup>
  </div>
  <template v-else />
</template>
